import {MapNode} from 'common/src/modules/nodes/nodes.types';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import {z} from 'zod';
import {BaseCardScratchpadState} from '../../scratchpad/baseCardScratchpad.types';
import {ToolExecuteParams} from 'common/src/modules/shared/copilot/copilot.types';
import validateAgentScratchpad from '../../utils/general/validateAgentScratchpad';
import {V2CardAgentToolName} from '../../promptToCardAgentV2.enums';
import {cardToText} from '../../cardDetailsV2/textualConverters';

export default function getCardDetailsTool() {
  async function execute(
    params: ToolExecuteParams<z.ZodObject<Record<string, never>>, BaseCardScratchpadState>,
  ) {
    const {agentScratchpad} = params.toolUtils;
    const validatedScratchpad = validateAgentScratchpad<BaseCardScratchpadState>(agentScratchpad);
    const {card} = validatedScratchpad;

    const text = cardToText(card as MapNode, 'full');

    if (text == null) {
      return toolResult(
        JSON.stringify({
          status: 'error',
          message: `Unsupported card type for getCardDetails: ${card.type}`,
        }),
      );
    }

    return toolResult(text);
  }

  return tool<z.ZodObject<Record<string, never>>, BaseCardScratchpadState>({
    name: V2CardAgentToolName.GetCardDetails,
    description: 'Retrieves full details of a card by its ID.',
    displayName: 'Getting card details',
    inputSchema: z.object({}),
    execute,
  });
}
